import { Directive, Input, TemplateRef } from '@angular/core';

export type DocTimelineTemplateType = 'content' | 'opposite' | 'marker';

@Directive({
  selector: '[docTimelineTemplate]',
  standalone: true,
})
export class DocTimelineTemplateDirective {
  @Input('docTimelineTemplate') type: DocTimelineTemplateType = 'content';

  constructor(public readonly template: TemplateRef<unknown>) {}
}
